export var isDefined = function (value) {
    return value !== undefined && value !== null;
};
//# sourceMappingURL=isDefined.js.map